import { Stack, Typography } from '@mui/material';
import React from 'react';

import CustomButton from '../../../components/button/ButtonComponent';
import { AutoPayBadgeStyles, AutoPayOffBadgeStyles } from '../../../components/global-styles/GlobalStyles';
import { ContractApiResponse } from '../../../services/contract-services';
import { useTranslation } from '../../../utils/translations';

interface ContractHeaderActionsProps {
    contract: ContractApiResponse;
    payNowDisabled: boolean;
    payNowTooltip: string;
    onEnableAutoPayClick: () => void;
    onPayNowClick: () => void;
}

export const ContractHeaderActions: React.FC<ContractHeaderActionsProps> = ({
    contract,
    payNowDisabled,
    payNowTooltip,
    onEnableAutoPayClick,
    onPayNowClick,
}) => {
    const { t } = useTranslation();

    return (
        <Stack
            direction={'row'}
            gap={2}
            justifyContent={'flex-end'}
            width={{ xs: '100%', md: 'fit-content' }}
            alignItems={'center'}
        >
            {contract?.AutoPay && !contract?.AutopayInProgress ? (
                <AutoPayBadgeStyles
                    direction="row"
                    alignItems="center"
                    justifyContent={{ xs: 'center', md: 'flex-start' }}
                    flex={{ xs: 1, md: 'unset' }}
                >
                    <span className="icon-check" />
                    <Typography variant="subtitle2" component="h1">
                        {t('common.AutoPay')}
                    </Typography>
                </AutoPayBadgeStyles>
            ) : contract.IsPrimary ? (
                <span style={{ display: 'flex', flex: 1 }}>
                    <CustomButton
                        variant="outlined"
                        sx={{
                            width: { xs: '100%', md: 'max-content' },
                        }}
                        onClick={onEnableAutoPayClick}
                        disabled={Boolean(contract?.AutopayInProgress && !contract?.AutoPay)}
                        disabledTooltip={
                            contract?.AutopayInProgress && !contract?.AutoPay
                                ? t('contracts.details.enableAutopayInProgress')
                                : ''
                        }
                    >
                        {t('contracts.details.enableAutoPay')}
                    </CustomButton>
                </span>
            ) : (
                <AutoPayOffBadgeStyles
                    direction="row"
                    alignItems="center"
                    justifyContent={{ xs: 'center', md: 'flex-start' }}
                    flex={{ xs: 1, md: 'unset' }}
                >
                    <Typography variant="subtitle2" component="h1">
                        {t('contracts.details.autoPayUnavailable')}
                    </Typography>
                </AutoPayOffBadgeStyles>
            )}
            <CustomButton
                variant="contained"
                sx={{
                    width: { xs: '100%', md: 'fit-content' },
                    flex: { xs: 1, md: 'unset' },
                    minWidth: 100,
                    fontWeight: 600,
                    transition: 'all 0.2s ease',
                    '&:hover:not(:disabled)': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    },
                }}
                disabled={payNowDisabled}
                onClick={onPayNowClick}
                disabledTooltip={payNowTooltip}
            >
                {t('contracts.details.makePayment')}
            </CustomButton>
        </Stack>
    );
};
